export const FORM_FIELD_NAMES = {
    REASON: "reason"
}